import { withStyles } from '@material-ui/core/styles';

export default withStyles((theme) => ({
  tabsRoot: {
    background: '#fff',
    minHeight: '28px',
  },
  tabsIndicator: {
    backgroundColor: '#eee',
    height: 0,
  },
  tabRoot: {
    color: 'rgba(0,0,0,.65)',
    fontSize: 15,
    minWidth: '70px',
    minHeight: '37px',
    background: 'white',
    textTransform: 'initial',
    fontWeight: 400,
    ['&$tabSelected' as any]: {
      color: '#192542',
      opacity: 1,
      borderRadius: '4px 4px 0 0',
    },
    '&:focus': {
      color: '#192542',
    },
    '& span': {
      fontSize: 14,
    },
  },
  tabSelected: {
    background: '#eee',
  },
  total: {
    position: 'relative',
    bottom: 0,
    left: 0,
    width: '100%',
    background: '#D9D9D9',
    padding: '0 1rem',
    borderBottomRightRadius: 4,
    borderBottomLeftRadius: 4,
    lineHeight: '2rem',
    fontWeight: 500,
    color: '#192542',
    marginTop: -2,
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '0.875rem',
  },
  customer: {
    fontSize: 14,
    lineHeight: '17px',
    fontWeight: 400,
    '& div': {
      display: 'block',
      marginBottom: 5,
      '& span': {
        color: '#192542',
        minWidth: '50px',
        display: 'inline-block',
        fontWeight: 500,
      },
    },
  },
  refundButton: {
    background: '#dc3f53',
    color: '#ffff',
    '&:hover': {
      background: '#dc3f53',
      color: '#ffff',
      transition: 'background-color 0.2s, box-shadow 0.3s',
    },
  },
  disableRefundButton: {
    background: '#dc3f53',
    color: '#ffff',
    transition: 'opacity .3s',
  },
  modal: {
    textAlign: 'left',
    padding: '20px 20px 0',
  },
  modalContent: {
    paddingTop: 20,
  },
  modalTitle: {
    width: '100%',
    display: 'block',
    fontSize: theme.typography.pxToRem(17),
    lineHeight: theme.typography.pxToRem(17),
    paddingRight: 50,
    color: '#222',
  },
  modalClose: {
    position: 'absolute',
    top: 14,
    right: 20,
    zIndex: 2,
    lineHeight: 0,
    '& span': {
      cursor: 'pointer',
      fontSize: theme.typography.pxToRem(25),
    },
  },
}));
